<template>
  <!-- MONITORING SITE HOME PAGE -->
  <v-container fluid class="monitorSite px-4 fade-in">
    <div class="welcome pb-1">Welcome to the FFS Monitoring Site...</div>
    <h1>Data Collection Status</h1>

    <v-row>
      <v-col>
        <div
          class="grid-caption mb-1"
        >Double click a row to view the list of agencies with this status.</div>
        <ag-grid-vue
          style="width: 600px; height: 240px"
          class="ag-theme-balham center-box elevation-2"
          :columnDefs="columnDefs"
          :rowData="rowData"
          @rowDoubleClicked="onRowDoubleClicked"
        ></ag-grid-vue>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs="12" md="6">
        <div class="admin-section elevation-2 pa-4">
          <column-chart :data="chartData"></column-chart>
        </div>
      </v-col>

      <v-col xs="12" md="6">
        <div class="admin-section elevation-2 pa-4">
          <pie-chart :data="chartData"></pie-chart>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { adminDataCollectionService } from "@/services/adminDataCollectionService.js";
import router from "@/router";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "AdminDataCollectionStats",
  data: () => ({
    columnDefs: null,
    rowData: null,
    chartData: [],
    footerRowData: []
  }),
  components: {
    AgGridVue
  },
  methods: {
    convertData () {
      this.chartData = [];
      this.rowData.forEach(element => {
        var tmp = [element.officeData, element.number];
        this.chartData.push(tmp);
      });
    },
    onRowDoubleClicked (evt) {
      debugger;
      const selectedRowData = evt.data;
      if (selectedRowData) {
        router.push({
          name: "admin.viewstats",
          params: { type: selectedRowData.id, id: -1 }
        });
      }
    }
  },
  mounted () {
    let me = this;
    adminDataCollectionService
      .getDataCollectionStats(0)
      .then(function (resp) {
        let finalRow;
        if (resp.data[5].id === 5) {
          let tmp = resp.data.splice(5, 1);
          finalRow = tmp[0];
        }

        me.rowData = resp.data;
        me.convertData();
        me.rowData.push({
          officeData: "Total",
          number: finalRow.number,
          percentage: "100%"
        });
      })
      .catch(function (err) {
        console.error(err);
      });

    this.columnDefs = [
      {
        headerName: "AGENCY DATA",
        field: "officeData",
        sortable: true,
        flex: 3,
        cellClass: "text-left"
      },
      { headerName: "Number", field: "number", sortable: true, flex: 1 },
      { headerName: "Percentage", field: "percentage", sortable: true, flex: 1 }
    ];
  }
};
</script>

<style scoped>
.welcome {
  text-align: left;
  font-size: 18pt;
  font-style: italic;
  margin: 0;
  /* color: #0f5182; */
}
.stats-box {
  border: 1px solid dimgray;
  border-radius: 5px;
  /* background-color: #d8e2f5; */
  background-color: #e8eef9;
}
.admin-section {
  border: 1px solid gray;
  background-color: white;
  border-radius: 5px;
}
</style>
